module.exports = "/virtual-football/img/video/clubs/italy/juventus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/italy/juventus.png
// module id = 300
// module chunks = 6